import classNames from 'classnames';
import {BOOK_TYPE, DOC_TYPE, IDocType} from '@/constants/document/doc';
import * as store from '@/store';
import sdk from '@/sdk';
import toast, {ToastType} from '@/components/Toast';
import Icon, {IconSize} from '@/components/Icon';
import {
    ArrowRightSvg, BookArrowRightSvg, HelpSvg, SidebarAddSvg,
    SidebarDataSheetSvg,
    SidebarImportSvg, SidebarLocalExcelSvg, SidebarLocalPDFSvg, SidebarLocalPPTSvg, SidebarLocalWordSvg,
    SidebarPagePublicSvg,
    SidebarPageSvg,
    SidebarPPTSvg,
    SidebarSheetSvg,
    SidebarTeamSvg,
    HelpBookSvg,
} from '@/icons';
import Text, {TextType} from '@/components/Text';
import TeamcatalogGuide from '@/components/guide/TeamcatalogGuide';
import Popover from '@/components/Popover';
import kuPiper from '@/middleware/kuPiper';
import {useIntl} from 'react-intl';
import {useEffect, useRef, useState} from 'react';
import {FileType} from '@/constants/document/file';
import {
    clickNewKnowledgeBook,
    feLogger,
    importExcelFromWeb,
    importPDFFromWeb,
    importPPTFromWeb,
    importWordFromWeb,
} from '@/buried';
import styles from './index.module.scss';
import {MenuPopper, Menu, MenuItem, Submenu} from '@baidu/luffy-comp-menu';
import {addBlur} from '../../sidebarTreeUtils';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import SidebarBookPublicSvg from '@/icons/SidebarBookCloseSvg';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {InheritRepo} from '@/Constant';

const renderOptions = (options?: any[]) => {
    if (!Array.isArray(options)) {
        return null;
    }

    return options.map((opt: any, index) => {
        const {children, value, label} = opt;

        if (!children) {
            return (
                <MenuItem key={value} id={opt.value} disabled={opt.disabled} onClick={opt.onClick}>
                    {label}
                </MenuItem>
            );
        }
        return (
            <Submenu
                key={`${opt.value}-sub`}
                itemContent={opt.label}
                type={'group'}
                disabled={opt.disabled}
                popperTriggerType={opt.popperTriggerType}
            >
                {renderOptions(children)}
            </Submenu>
        );
    });
};

const OPENBOOK_TYPE = 5;

const KnowledgeBookDetails = 'https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/Jw3ESeeIzA/wX6S4XS3VZk0xr';
const DataSheetNeedDetails = 'https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/munIPCvcFy/-uKiHB6zZTw4gD';

// eslint-disable-next-line max-statements
function SidebarAddMenu({sidebarMenuTarget}: any) {
    const node = sidebarMenuTarget?.node;
    const isTreeRoot = !!sidebarMenuTarget?.isTreeRoot;
    const intl = useIntl();
    const [visible, setVisible] = useState(false);
    const [showGuide, setShowGuide] = useState(false);

    const {docGuid = ''} = node || {};
    const isBook = node?.bookType === BOOK_TYPE.IS_BOOK;
    const inBook = node?.bookType === BOOK_TYPE.IN_BOOK;
    const repository = store.getCurRepository();

    function handleAddDoc() {
        const bookType = isBook || inBook ? BOOK_TYPE.IN_BOOK : BOOK_TYPE.NO_BOOK;
        // todo !treeUtils.isExpanded(treeId, id) && treeUtils.setExpanded(treeId, id, true);
        store.setCreateDocument({
            docType: DOC_TYPE.DOCUMENT,
            bookType,
            parentGuid: isTreeRoot ? '' : docGuid,
        });
    }

    function handleAddSheet() {
        const bookType = isBook || inBook ? BOOK_TYPE.IN_BOOK : BOOK_TYPE.NO_BOOK;
        // todo !treeUtils.isExpanded(treeId, id) && treeUtils.setExpanded(treeId, id, true);
        store.setCreateDocument({
            docType: DOC_TYPE.SHEET,
            bookType,
            parentGuid: isTreeRoot ? '' : docGuid,
        });
    }

    function handleAddPPT() {
        const bookType = isBook || inBook ? BOOK_TYPE.IN_BOOK : BOOK_TYPE.NO_BOOK;
        // todo !treeUtils.isExpanded(treeId, id) && treeUtils.setExpanded(treeId, id, true);
        store.setCreateDocument({
            docType: DOC_TYPE.PPT,
            bookType,
            parentGuid: isTreeRoot ? '' : docGuid,
        });
    }

    function handleAddDataSheet() {
        const bookType = isBook || inBook ? BOOK_TYPE.IN_BOOK : BOOK_TYPE.NO_BOOK;
        store.setDstTplDialogData({
            visible: true,
            successCb: (templateId) => {
                // todo !treeUtils.isExpanded(treeId, id) && treeUtils.setExpanded(treeId, id, true);
                store.setCreateDocument({
                    docType: DOC_TYPE.DATASHEET,
                    bookType,
                    parentGuid: isTreeRoot ? '' : docGuid,
                    templateId,
                });
            },
        });
    }

    async function handleAddDirectory(inherit?: number, scope?: number) {
        // todo !treeUtils.isExpanded(treeId, id) && treeUtils.setExpanded(treeId, id, true);
        store.setCreateDirectory(
            isTreeRoot ? '' : docGuid,
            isTreeRoot ? '2' : '3',
            undefined, // openInNewTab
            undefined, // createPersonPage
            inherit,
            scope
        );

        setVisible(false);
        store.setSidebarMenuTarget(null);

    }

    /**
     * 点击导入事件
     * @param fileType 文件类型
     */
    const handleClickImportFile = (fileType: FileType) => {
        if (fileType === FileType.Excel) {
            // 导入 Excel 时，需要弹窗二次选择
            store.setImportExcelDialogData({
                visible: true,
                curDocument: node,
                source: 'sidebar',
                repositoryGuid: node ? node?.repositoryGuid : '',
                userGuid: sdk.user && sdk.user?.userGuid,
            });
        } else {
            // 导入逻辑统一放置 UploadInput 组件
            store.setUploadInputOptions({
                fileType,
                curDocument: node,
                source: 'sidebar',
            });
        }
        // 上报埋点参数
        const buriedParams = {
            kb_id: node ? node?.repositoryGuid : '',
            userid: sdk.user && sdk.user?.userGuid,
            source: 'sidebar',
        };
        switch (fileType) {
            case FileType.PPT:
                feLogger(importPPTFromWeb(buriedParams));
                break;
            case FileType.Word:
                feLogger(importWordFromWeb(buriedParams));
                break;
            case FileType.PDF:
                feLogger(importPDFFromWeb(buriedParams));
                break;
            default:
                break;
        }
        setVisible(false);
        store.setSidebarMenuTarget(null);
    };

    async function createDoc(type: IDocType) {
        if (!repository) {
            return;
        }
        // 现在新建文档的时候父元素最多只能有1000个节点
        const ksServer = await sdk.getKsServer(repository);
        ksServer.getDocumentsNew({
            parentGuid: node ? node.docGuid : '',
        }).then(result => {
            if (result && result.length >= 1000) {
                toast({
                    content: '创建失败，同一级目录不能超过 1000 个',
                    type: ToastType.Error,
                });
            } else {
                // 集中处理创建逻辑
                switch (type) {
                    case DOC_TYPE.DOCUMENT:
                        handleAddDoc();
                        break;
                    case DOC_TYPE.SHEET:
                        handleAddSheet();
                        break;
                    case DOC_TYPE.PPT:
                        handleAddPPT();
                        break;
                    case DOC_TYPE.DATASHEET:
                        handleAddDataSheet();
                        break;
                }
                if (type === DOC_TYPE.DIRECTORY) {
                    handleAddDirectory();
                }
            }
            setVisible(false);
            store.setSidebarMenuTarget(null);
        });
    }


    async function onCloseDirectory() {
        setVisible(false);
        setShowGuide(false);
        await sdk.as.updateNewGuide({
            newBuildIsRead: true,
            createDirectoryGuideIsRead: true,
        });
        // store.setNewGuideData(4);
    }

    const needBlur = useRef(true);

    function handleImportMouseOver() {
        needBlur.current = false;
    }

    function handleImportMouseLeave() {
        needBlur.current = true;
    }

    // 知识本点击查看 使用手册
    const handleClickKnowledgeBookDetails = () => {
        window.open(KnowledgeBookDetails);
    };

    // 导入在线文档二级选择
    const importPopArea = (
        <div
            className={styles.importPopArea}
            onMouseOver={handleImportMouseOver}
            onMouseLeave={handleImportMouseLeave}
        >
            {
                kuPiper.openNormalReplaceSlot(
                    {
                        scope: kuPiper.slotScopeMap.SpaceRepo,
                        position: kuPiper.slotPositionMap.SpaceRepo.ImportLocalFile,
                        DefaultComponent: <div
                            className={classNames(styles.oneLine, styles.item)}
                            onClick={() => handleClickImportFile(FileType.Word)}
                        >
                            <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarLocalWordSvg} noSpace />
                            <Text type={TextType.T13}>{intl.formatMessage({id: 'labelImportWord'})}</Text>
                        </div>,
                    }
                )
            }
            <div
                className={classNames(styles.oneLine, styles.item)}
                onClick={() => handleClickImportFile(FileType.Excel)}
            >
                <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarLocalExcelSvg} noSpace />
                <Text type={TextType.T13}>{intl.formatMessage({id: 'labelImportExcel'})}</Text>
            </div>
            <div
                className={classNames(styles.oneLine, styles.item)}
                onClick={() => handleClickImportFile(FileType.PPT)}
            >
                <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarLocalPPTSvg} noSpace />
                <Text type={TextType.T13}>{intl.formatMessage({id: 'labelImportPPT'})}</Text>
            </div>
            <div
                className={classNames(styles.oneLine, styles.item)}
                onClick={() => handleClickImportFile(FileType.PDF)}
            >
                <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarLocalPDFSvg} noSpace />
                <Text type={TextType.T13}>{intl.formatMessage({id: 'labelImportPDF'})}</Text>
            </div>
        </div>
    );

    const baseLogParams = {
        docGuid: node?.docGuid || '',
        repository_id: node?.repositoryGuid || repository?.repositoryGuid || '',
        userId: sdk.as.user?.userGuid || '',
        CreateCource: isTreeRoot ? 'RootTreeAdd' : 'RegularPageAdd',
    };
    const logBookClick = (BookType: 'RegularBook' | 'OpenBook' | 'SafeBook') => {
        feLogger(clickNewKnowledgeBook({
            ...baseLogParams,
            BookType,
        }));
    };
    // 创建知识本二级菜单
    const bookSubmenu = (
        <div
            onMouseOver={handleImportMouseOver}
            onMouseLeave={handleImportMouseLeave}
            className={classNames(
                styles.importBookSubmenu,
                (isBook || inBook) && node?.rootGuid && styles.importBookDisableSty)}
        >
            <div
                className={styles.item}
                onClick={() => {
                    handleAddDirectory();
                    logBookClick('RegularBook');
                }}
            >
                <Icon
                    svg={SidebarTeamSvg}
                    size={IconSize.XXL}
                    className={styles.bookSubmenuIcon}
                    noSpace
                />
                <div className={styles.itemContent}>
                    <Text type={TextType.T14}>{intl.formatMessage({id: 'labelOrdinaryKnowledge'})}</Text>
                    <p>{intl.formatMessage({id: 'labelOrdinaryKnowledgeText'})}</p>
                </div>
            </div>
            {
                repository?.external ? null : <div
                    className={styles.item}
                    onClick={() => {
                        handleAddDirectory(InheritRepo.Inherit, OPENBOOK_TYPE);
                        logBookClick('OpenBook');
                    }}
                >
                    <Icon
                        svg={SidebarPagePublicSvg}
                        size={IconSize.XXL}
                        className={styles.bookSubmenuIcon}
                        noSpace
                    />
                    <div className={styles.itemContent}>
                        <Text type={TextType.T14}>{intl.formatMessage({id: 'labelOpenKnowledge'})}</Text>
                        <p>{intl.formatMessage({id: 'labelOpenKnowledgeText'})}</p>
                    </div>
                </div>
            }
            <div
                className={styles.item}
                onClick={() => {
                    handleAddDirectory(InheritRepo.Not_Inherit);
                    logBookClick('SafeBook');
                }}
            >
                <Icon
                    svg={SidebarBookPublicSvg}
                    size={IconSize.XXL}
                    className={styles.bookSubmenuIcon}
                    noSpace
                />
                <div className={styles.itemContent}>
                    <Text type={TextType.T14}>{intl.formatMessage({id: 'labelSecrecyKnowledge'})}</Text>
                    <p>{intl.formatMessage({id: 'labelSecrecyKnowledgeText'})}</p>
                </div>
            </div>
        </div>
    );

    const originCreateOptions = [
        {
            label: (
                <div className={styles.oneLine}>
                    <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarPageSvg} noSpace />
                    <Text type={TextType.T13}>
                        {intl.formatMessage({id: 'labelCreateDocument'})}
                    </Text>
                </div>
            ),
            value: 'document',
            onClick() {
                createDoc(DOC_TYPE.DOCUMENT);
            },
        },
        {
            label: (
                <div className={styles.oneLine}>
                    <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarSheetSvg} noSpace />
                    <Text type={TextType.T13}>
                        {intl.formatMessage({id: 'labelCreateSheet'})}
                    </Text>
                </div>
            ),
            value: 'sheet',
            onClick() {
                createDoc(DOC_TYPE.SHEET);
            },
        },
        {
            value: 'datasheet',
            children: [
                {
                    label: (
                        <Popover
                            className={styles.importOneLine}
                            type={'hover'}
                            placement={'right-start'}
                            withArrow={false}
                        >
                            <div
                                className={styles.oneLineWarp}
                                onClick={() => {
                                    createDoc(DOC_TYPE.DATASHEET);
                                }}
                            >
                                <div className={classNames(styles.oneLineLeft)}>
                                    <Icon
                                        className={styles.oneLineIcon}
                                        size={IconSize.LG}
                                        svg={SidebarDataSheetSvg}
                                        noSpace
                                    />
                                    <Text type={TextType.T13}>
                                        {intl.formatMessage({id: 'labelCreateDataSheet'})}
                                    </Text>
                                    <Tooltip
                                        placement="top"
                                        className={styles.tip}
                                        content={
                                            <>
                                                快速上手数据表，更多介绍请点击&nbsp;
                                                <span
                                                    onMouseDown={() => {
                                                        window.open(DataSheetNeedDetails);
                                                    }}
                                                    className={styles.link}
                                                >前往查看</span>
                                            </>
                                        }
                                    >
                                        <Icon svg={HelpBookSvg} className={styles.helpSvg} />
                                    </Tooltip>
                                </div>
                            </div>
                        </Popover>
                    ),
                    value: 'datasheet',
                    disabled: false,
                },
            ],
        },
        {
            label: (
                <div className={styles.oneLine}>
                    <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarPPTSvg} noSpace />
                    <Text type={TextType.T13}>
                        {intl.formatMessage({id: 'labelCreatePPT'})}
                    </Text>
                </div>
            ),
            value: 'ppt',
            onClick() {
                createDoc(DOC_TYPE.PPT);
            },
        },
        // 小流量已全量，打开被注释内容
        {
            value: 'group_directory',
            children: [
                {
                    label: (
                        <Popover
                            className={styles.importOneLine}
                            type={'hover'}
                            placement={'right-start'}
                            withArrow={false}
                            content={bookSubmenu}
                        >
                            <div className={styles.oneLineWarp}>
                                <div className={classNames(styles.oneLineLeft,
                                    (isBook || inBook) && node?.rootGuid && styles.disableSty)}
                                >
                                    <Icon
                                        className={styles.oneLineIcon}
                                        size={IconSize.LG}
                                        svg={SidebarTeamSvg}
                                        noSpace
                                    />
                                    <Text type={TextType.T13}>
                                        {intl.formatMessage({id: 'labelCreateDirectory'})}
                                    </Text>
                                    <Tooltip
                                        placement="top"
                                        className={styles.tip}
                                        content={(isBook || inBook) && node?.rootGuid ? (
                                            <>
                                                不支持在知识本内新建知识本。详细介绍请点击&nbsp;
                                                <span
                                                    onMouseDown={handleClickKnowledgeBookDetails}
                                                    className={styles.link}
                                                >前往查看</span>
                                            </>
                                        ) : (
                                            <>
                                                用于在知识库内单独管理权限。详细介绍请点击&nbsp;
                                                <span
                                                    onMouseDown={handleClickKnowledgeBookDetails}
                                                    className={styles.link}
                                                >前往查看</span>
                                            </>
                                        )}
                                    >
                                        <Icon svg={HelpBookSvg} className={styles.helpSvg} />
                                    </Tooltip>
                                </div>
                                <Icon
                                    svg={BookArrowRightSvg}
                                    className={classNames(
                                        styles.arrowRight,
                                        (isBook || inBook) && node?.rootGuid && styles.importBookDisableSty)}
                                    noSpace
                                />
                            </div>
                            {
                                showGuide ? <TeamcatalogGuide
                                    onKnownHandle={onCloseDirectory}
                                    className={styles.teamGuide}
                                    type={'directory'}
                                /> : null
                            }
                        </Popover>
                    ),
                    value: 'directory',
                    disabled: true,
                },
            ],
        },
        {
            value: 'group_second',
            children: [
                {
                    label: (
                        <Popover
                            className={styles.importPopover}
                            type={'hover'}
                            placement={'left-start'}
                            withArrow={false}
                            content={importPopArea}
                        >
                            <div className={styles.groupOneLine}>
                                <Icon className={styles.iconPos} size={IconSize.LG} svg={SidebarImportSvg} noSpace />
                                <Text type={TextType.T13}>{intl.formatMessage({id: 'labelImportFile'})}</Text>
                                <Icon
                                    svg={BookArrowRightSvg}
                                    className={styles.arrow}
                                    noSpace
                                />
                            </div>
                        </Popover>
                    ),
                    value: 'import_file',
                    disabled: true,
                },
            ],
        },
    ];
    const createOptions = kuPiper.openListSlot(
        {
            scope: kuPiper.slotScopeMap.SpaceRepo,
            position: kuPiper.slotPositionMap.SpaceRepo.TreeCreateMenu,
            originList: originCreateOptions,
        }
    );

    function handleChange(val: boolean) {
        setVisible(val);
        store.setSidebarMenuTarget(null);
    }

    useEffect(() => {
        if (sidebarMenuTarget) {
            setVisible(true);
        }
    }, [sidebarMenuTarget]);

    if (!sidebarMenuTarget || sidebarMenuTarget.type !== 'add') {
        return null;
    }

    const options = createOptions.filter(option => option.visible !== false);

    function blurMenu() {
        if (!needBlur.current) {
            return;
        }
        handleChange(false);
    }

    const getAddMenuRef = (ref: any) => {
        if (!ref) {
            return;
        }
        addBlur('.sidebar-add-menu', blurMenu);
    };


    return (
        <MenuPopper
            visible={visible}
            type={'click'}
            size={'lg'}
            target={sidebarMenuTarget.element}
            className={styles.createMenu}
            placement={'bottom-end'}
            withArrow={false}
            onChange={handleChange}
        >
            <Menu
                type={'common'}
                submenuPopperTriggerType={'hover'}
                className="sidebar-add-menu"
                ref={getAddMenuRef}
            >
                {
                    renderOptions(options)
                }
            </Menu>
        </MenuPopper>
    );
}

export default store.connect([
    store.KEYS.SIDEBAR_MENU_TARGET,
])(SidebarAddMenu);
